<template>
  <div class="login-form">
    <van-form @submit="handleLogin">
      <van-field v-model="username" name="用户名" label="用户名" placeholder="用户名"
        :rules="[{ required: true, message: '请填写用户名' }]" />
      <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
        :rules="[{ required: true, message: '请填写密码' }]" />
      <van-field v-model="smsVerifyCode" name="验证码" label="验证码" placeholder="验证码" :rules="[{ required: true, message: '请填写验证码' }]">
        <template v-if="!captcha" #button>
          <van-button size="small" type="info" @click="getCaptcha" native-type="button">获取验证码</van-button>
        </template>
        <template v-if="captcha" #extra>
            <img height="100%" :src="captcha" @click="getCaptcha">
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Base64 } from "js-base64";

export default {

  data() {
    return {
      username: '',
      password: '',
      smsVerifyCode: "",
      captcha: null,//验证码
      countdown: 300,// 倒计时300秒
      countdownTimer: null,//定时任务实例对象
    };
  },
  computed: {
    canSendCode() {
      let _self = this;
      return _self.countdown === 300;
    },
    sendCodeText() {
      let _self = this;
      return _self.countdown === 300 ? '发送验证码' : _self.countdown + '秒重发';
    }
  },
  methods: {
    // 获取图形验证码
    getCaptcha() {
      let _self = this;
      if (!_self.username) {
        _self.$toast.fail("请输入用户名");
        return;
      }
      _self.$api.user
        .captcha({ username: _self.username })
        .then(
          (res) => {
            _self.captcha = URL.createObjectURL(new Blob([res], { type: 'image/png' }));
          },
          (error) => {
            console.log(error);
            _self.$toast.fail("服务器忙，请稍后重试");
          }
        )
        .catch((res) => {
          _self.$toast.fail(res.returnMsg);
        });
    },
    //发送短信验证码
    sendVerifyCode() {
      let _self = this;
      _self.$api.user
        .sendSmsVerifyCode({ username: _self.username, password: _self.password, smsVerifyCode: _self.smsVerifyCode })
        .then(
          (res) => {
            if (res.returnCode === 200) {
              _self.countdownTimer = setInterval(() => {
                if (_self.countdown > 0) {
                  _self.countdown--;
                } else {
                  clearInterval(_self.countdownTimer);
                }
              }, 1000);
            } else {
              _self.$toast.fail(res.returnMsg);
            }
          },
          (error) => {
            console.log(error);
            _self.$toast.fail("服务器忙，请稍后重试");
          }
        )
        .catch((res) => {
          _self.$toast.fail(res.returnMsg);
        });
    },
    // 登录
    handleLogin() {
      let _self = this;
      _self.$api.user
        .login({ username: _self.username, password: _self.password, smsVerifyCode: _self.smsVerifyCode })
        .then(
          res => {
            if (res.returnCode === 200) {
              // 1.保存jwt令牌到localStorage中
              localStorage.setItem("token", res.data);
              // 2.解析jwt令牌中的用户信息并存储到localStorage中
              let userInfo = JSON.parse(Base64.decode(res.data.split(".")[1]));
              localStorage.setItem("id", userInfo.id);
              localStorage.setItem("username", userInfo.username);
              localStorage.setItem("avatar", userInfo.avatar);
              localStorage.setItem("nickname", userInfo.nickname);
              // 3.登录成功，跳转到主页中
              _self.$router.push("/home");
            } else {
              _self.$toast.fail(res.returnMsg);
            }
          },
          error => {
            console.log(error);
            _self.$toast.fail("服务器忙，请稍后重试");
          }
        )
        .catch(err => {
          console.log(err);
        });
    },
  },
  beforeDestroy() {
    // 在这里执行清理操作，比如取消定时器、取消事件监听器等
    let _self = this;
    if (_self.countdownTimer) {
      clearInterval(_self.countdownTimer);
    }
  },
}
</script>

<style scoped>
.login-form {
  margin-top: 30px;
}
</style>